{
  "fr": {
    "baseBtn": {
      "labels": {
        "loading": "Veuillez patienter..."
      },
      "confirm": {
        "question": "Sûr ?",
        "yes": "Oui",
        "no": "Non"
      }
    }
  }
}
